(function($) {
    $.fn.instagramGallery = function(options) {
        var defaults = {
            token: null,
            limit: 9,
            markup: function() {
                return '<li class="item" data-aos="fade">'+
                    '<a href="{{largeSrc}}">'+
                        '<img class="img-fluid rounded" src="{{thumbSrc}}" alt="{{caption}}" width="{{thumbWidth}}" height"{{thumbHeight}}" data-original-src="{{largeSrc}}" data-original-src-width="{{largeWidth}}" data-original-src-height="{{largeHeight}}" />'+
                    '</a>'+
                '</li>';
            },
            complete: function(){},
        };
        var configs = $.extend('', defaults, options);

        return this.each(function() {
            var $el = $(this);
            var token = (configs.token) ? configs.token : this.dataset.instagramGallery;
            var url = 'https://api.instagram.com/v1/users/self/media/recent';
            var data = $.getJSON({
                url: url,
                data: {
                    access_token: token,
                },
                complete: function() {
                    return configs.complete($el);
                }
            });

            data.done(function(response) {
                var images  = response.data;
                var limit   = Math.min(configs.limit, images.length);

                for (var i = 0; i <= limit-1; i++) {
                    var img     = images[i];
                    var caption = (img.caption) ? img.caption.text : '';
                    var thumb   = {
                        src: img.images.thumbnail.url,
                        width: img.images.thumbnail.width,
                        height: img.images.thumbnail.height,
                    };
                    var large   = {
                        src: img.images.standard_resolution.url,
                        width: img.images.standard_resolution.width,
                        height: img.images.standard_resolution.height,
                    };
                    var markup = configs.markup();
                    var html = replaceArray( markup, [
                        ['{{caption}}', caption],
                        ['{{thumbSrc}}', thumb.src],
                        ['{{thumbWidth}}', thumb.width],
                        ['{{thumbHeight}}', thumb.height],
                        ['{{largeSrc}}', large.src],
                        ['{{largeWidth}}', large.width],
                        ['{{largeHeight}}', large.height]
                    ] );

                    $el.append(html);
                }
            });
        });

        function replaceArray( string, object ) {
            var replaceStr = string;
            object.forEach(function(el) {
                var oldStr = new RegExp(el[0], 'gi');
                var newStr = el[1];
                replaceStr = replaceStr.replace(oldStr, newStr);
            });
            return replaceStr;
        }
    }
})(jQuery);